module.exports = __webpack_public_path__ + "ef4d7e959a28338df9343366a5c4c067.MP3";